import { render, staticRenderFns } from "./bottomInfoPop.vue?vue&type=template&id=5fe2b9a4&scoped=true"
import script from "./bottomInfoPop.vue?vue&type=script&lang=js"
export * from "./bottomInfoPop.vue?vue&type=script&lang=js"
import style0 from "./bottomInfoPop.vue?vue&type=style&index=0&id=5fe2b9a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe2b9a4",
  null
  
)

export default component.exports